module.exports = "\n<!-- Wrapper used to force footer to bottom of page/screen -->\n<div id=\"wrapper\">\n  \n  <app-header></app-header>\n\n  <router-outlet></router-outlet>\n\n</div>\n\n\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Jeremy/Desktop/EFA/jerusalem-temple/src/app/app/app.component.html
// module id = ../../../../../src/app/app/app.component.html
// module chunks = main